import { dataTrashSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrashSolid = /*#__PURE__*/createIcon(dataTrashSolid)
export default IconTrashSolid
